import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces/stateExtended'

export function usePusherDataSelector() {
  const pusherData = useSelector(
    (state: StateExtended) => state.pusher.pusherData,
  )
  return pusherData
}